import { render } from "./BillingForm.vue?vue&type=template&id=4e48a5fb&scoped=true"
import script from "./BillingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingForm.vue?vue&type=script&setup=true&lang=js"

import "./BillingForm.vue?vue&type=style&index=0&id=4e48a5fb&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e48a5fb"],['__file',"src/modules/billing/components/BillingForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e48a5fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e48a5fb', __exports__)) {
    console.log('reload')
    api.reload('4e48a5fb', __exports__)
  }
  
  module.hot.accept("./BillingForm.vue?vue&type=template&id=4e48a5fb&scoped=true", () => {
    console.log('re-render')
    api.rerender('4e48a5fb', render)
  })

}


export default __exports__